import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { ChannelSelectionService } from 'src/app/modules/communications/services/channel-selection-service';
import { TextWithStatusCellData } from './text-with-status-model';

@Component({
    selector: 'app-text-with-status-cell',
    templateUrl: './text-with-status-cell.component.html',
    styleUrls: ['./text-with-status-cell.component.scss'],
    standalone: false
})
export class TextWithStatusCellComponent implements ICellRendererAngularComp {
  data: TextWithStatusCellData;

  constructor(private translateService: TranslateService, private channelSelectionService: ChannelSelectionService) {}

  agInit(params: any): void {
    this.data = this.generateStatusText(this.getValueToDisplay(params));
  }

  refresh(params: ICellRendererParams): boolean {
    this.data = this.generateStatusText(this.getValueToDisplay(params));
    return true;
  }

  private generateStatusText(value: string): TextWithStatusCellData {
    if (!!value) {
      try {
        const ret = JSON.parse(value);
        return ret;
      }
      catch(e) {
      }
    }
    return null;
  }

  getValueToDisplay(params: any) {
    return params.value;
  }
}
